import React from "react";
import { Reveal, SectionHeading } from "./_shared";

const benefits = [
    {
        title: "Priorità immediatamente visibili",
        text: "Consulta rapidamente ciò che è valido, ciò che sta per scadere e ciò che deve essere gestito.",
        stat: "1 dashboard",
        statLabel: "invece di 4 fogli Excel",
    },
    {
        title: "Informazioni organizzate",
        text: "Collega aziende, sedi, lavoratori, formazione, visite mediche e sopralluoghi.",
        stat: "0 ricerche",
        statLabel: "sparse tra archivi",
    },
    {
        title: "Gestione più semplice",
        text: "Riduci la necessità di utilizzare fogli, email, archivi e promemoria separati.",
        stat: "1 luogo",
        statLabel: "per adempimento",
    },
    {
        title: "Esperienza concreta",
        text: "SafetyDesk81 nasce dall'esperienza di Centro Sicurezza Consulenze nella gestione quotidiana della sicurezza aziendale.",
        stat: "20+ anni",
        statLabel: "di consulenza HSE",
    },
];

export default function Benefits() {
    return (
        <section id="benefici" className="py-24 md:py-32 bg-navy-950 text-white relative overflow-hidden">
            <div aria-hidden className="absolute inset-0 bg-grid-navy opacity-60 pointer-events-none" />
            <div aria-hidden className="absolute -top-20 -left-20 w-[400px] h-[400px] bg-gold-400/10 blur-3xl rounded-full" />
            <div aria-hidden className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-navy-700/40 blur-3xl rounded-full" />

            <div className="relative max-w-[1400px] mx-auto px-5 md:px-8">
                <SectionHeading
                    chapter={4}
                    chapterLabel="Benefici"
                    title={
                        <span className="text-white">
                            Più controllo. <span className="text-gold-400">Meno attività disperse.</span>
                        </span>
                    }
                    className="text-white"
                />

                <div className="grid md:grid-cols-2 gap-5 md:gap-6 mt-14">
                    {benefits.map((b, i) => (
                        <Reveal key={b.title} delay={i * 0.08}>
                            <article
                                data-testid={`benefit-${i}`}
                                className="rounded-3xl p-8 md:p-10 bg-white/[0.03] border border-white/10 backdrop-blur-sm relative overflow-hidden hover:border-gold-400/40 hover:bg-white/[0.05] transition-all duration-300 group h-full"
                            >
                                <div className="flex items-baseline justify-between gap-6">
                                    <div className="font-display text-[44px] md:text-[56px] font-black text-gold-400 leading-none">
                                        {b.stat}
                                    </div>
                                    <div className="text-white/50 text-xs uppercase tracking-widest text-right max-w-[140px]">
                                        {b.statLabel}
                                    </div>
                                </div>
                                <div className="mt-6 pt-6 border-t border-white/10">
                                    <h3 className="font-display font-bold text-white text-xl md:text-2xl">{b.title}</h3>
                                    <p className="mt-3 text-white/70 leading-relaxed">{b.text}</p>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
